import type { ExtractedField } from "../types"
import { AssignmentCard } from "./AssignmentCard"

interface CounterpartyAssignmentCardProps {
  title: string
  fields: ExtractedField[]
  renderField: (field: ExtractedField) => JSX.Element
}

export const CounterpartyAssignmentCard = ({ title, fields, renderField }: CounterpartyAssignmentCardProps): JSX.Element => {
  const isEmpty = fields.length === 0

  return (
    <AssignmentCard title={title}>
      {isEmpty ? (
        <div className="px-2 py-4 text-sm text-gray-400 italic text-center">
          No counterparty data available
        </div>
      ) : (
        <div className="w-full flex-1 flex flex-col">
          {fields.map(renderField)}
        </div>
      )}
    </AssignmentCard>
  )
}
